import { render, staticRenderFns } from "./TrocaTurma.vue?vue&type=template&id=1de52f56&"
import script from "./TrocaTurma.vue?vue&type=script&lang=js&"
export * from "./TrocaTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports